import { Box, Container, Stack } from '@mui/material';

import { useSpotterErrorPage } from '@/components/layouts/SpotterLayout';
import { SpotterDetailsHeader } from '@/components/spotter/SpotterDetailsHeader';
import { HistoricalDataTabContainer } from '@/components/spotter/historicalDataTab/ObservationDataTabContainer';

export const PublicSpotterDetails = () => {
    const { errorPage } = useSpotterErrorPage();

    if (errorPage) {
        return errorPage;
    }

    return (
        <Container maxWidth={false}>
            <Box sx={{ width: 1 }}>
                <Stack
                    direction="row"
                    sx={{
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <SpotterDetailsHeader />
                </Stack>
                <Box sx={{ py: 3, px: 1 }}>
                    <HistoricalDataTabContainer noSensorAlerts />
                </Box>
            </Box>
        </Container>
    );
};
